<template>
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.4396 19.3048L11.4396 3.5748" stroke="currentColor" stroke-width="1.43" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.8751 10.0099L11.4401 3.57488L5.00512 10.0099" stroke="currentColor" stroke-width="1.43" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
